/** The directory Computer's backends and tools treat as the working root. */
export const WORKSPACE_ROOT = "/workspace";
